
import {
  defineComponent,
  SetupContext,
  PropType,
  computed
} from "vue";
import NativeClient from "@/client/native-client";
import store from "@/store";
import {
  RecognitionCandidate,
  CandidateInfo,
  RequestRecognitionCandidateItem,
  StatusCameraCheck
} from "@/types/pantry";
import PantryCameraCheckBottomView from "./PantryCameraCheckBottomView.vue";
import PantryCameraCheckSelectView from "./PantryCameraCheckSelectView.vue";
import router from "@/router";
export default defineComponent({
  name: "PantryCameraCheckMainView",
  components: {
    PantryCameraCheckBottomView,
    PantryCameraCheckSelectView
  },
  props: {
    data: {
      type: RecognitionCandidate,
      default: null,
      required: true
    },
    foodList: {
      type: Array as PropType<RequestRecognitionCandidateItem[]>,
      default: [],
      required: true
    },
    selectPosition: {
      type: Number,
      default: 0,
      required: true
    },
    update: {
      type: Number,
      default: 0,
      required: true
    },
    isFoodTimerExec: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const singleMode = computed(() => {
      NativeClient.sendDebugLog(
        "PantryCameraCheckMainView singleMode foodList=" + JSON.stringify(props.foodList)
      );
      NativeClient.sendDebugLog(
        "PantryCameraCheckMainView singleMode selectPosition=" + JSON.stringify(props.selectPosition)
      );
      return props.foodList.length <= 1;
    });
    const clickClose = () => {
      context.emit("click-close");
    };

    const onClickBack = () => {
      context.emit("click-back");
    };

    const onClickSkip = () => {
      context.emit("click-skip");
    };

    const onClickFood = (inferenceResultFoodId: number, data: CandidateInfo) => {
      NativeClient.sendDebugLog(
        "PantryCameraCheckMainView onClickFood inferenceResultFoodId=" + inferenceResultFoodId + " data=" + JSON.stringify(data)
      );
      context.emit("click-food", inferenceResultFoodId, data);
    };

    const onClickInput = (inferenceResultFoodId: number, data: CandidateInfo) => {
      NativeClient.sendDebugLog(
        "PantryCameraCheckMainView onClickInput inferenceResultFoodId=" + inferenceResultFoodId + " data=" + JSON.stringify(data)
      );
      context.emit("click-input", inferenceResultFoodId, data);
    };

    const onFoodSearchClose = () => {
      context.emit("click-close");
    };

    const onStatus = (status: StatusCameraCheck) => {
      context.emit("status", status);
    };

    const selectImage = (fileName: string) => {
      context.emit("select-image", fileName);
    };

    return {
      clickClose,
      onClickSkip,
      onClickBack,
      onClickFood,
      onFoodSearchClose,
      singleMode,
      onClickInput,
      onStatus,
      selectImage
    };
  }
});
